import { Action } from "../actionTypes";

const initState = {
    AllUser: [],
    AllB2BAccounts: [],
    AllReferrals: [],
    AllOfferCodes: [],
    AllAffiliates: [],
    AllCustomPlans: [],
    offerCode: {},
    referral: {},
    affiliate: {},
    customPlan: {},
    planFeatures: {},
    UserById: [],
    downloaduser: [],
    error: "",
};

const store = (state = initState, action: any) => {
    switch (action.type) {
        // B2B Account management
        case Action.ADMIN_GET_B2B_ACCOUNTS_INIT:
            return {
                ...state
            }
        case Action.ADMIN_GET_B2B_ACCOUNTS_SUCCESS:
            return {
                ...state,
                AllB2BAccounts: action?.payload
            }
        case Action.ADMIN_GET_B2B_ACCOUNTS_FAIL:
            return {
                ...state,
                error: action?.payload
            }
            
        case Action.ADMIN_CREATE_B2B_ACCOUNT_INIT:
            return {
                ...state
            }
        case Action.ADMIN_CREATE_B2B_ACCOUNT_SUCCESS:
            return {
                ...state,
                AllB2BAccounts: [...state.AllB2BAccounts, action?.payload]
            }
        case Action.ADMIN_CREATE_B2B_ACCOUNT_FAIL:
            return {
                ...state,
                error: action?.payload
            }
            
        case Action.ADMIN_UPDATE_B2B_ACCOUNT_INIT:
            return {
                ...state
            }
        case Action.ADMIN_UPDATE_B2B_ACCOUNT_SUCCESS:
            return {
                ...state,
                AllB2BAccounts: state.AllB2BAccounts.map((account: any) => 
                    account.id === action?.payload.accountId 
                        ? { ...account, ...action?.payload.updatedData }
                        : account
                )
            }
        case Action.ADMIN_UPDATE_B2B_ACCOUNT_FAIL:
            return {
                ...state,
                error: action?.payload
            }
            
        case Action.ADMIN_SEND_INVITATION_INIT:
            return {
                ...state
            }
        case Action.ADMIN_SEND_INVITATION_SUCCESS:
            return {
                ...state,
                error: ""
            }
        case Action.ADMIN_SEND_INVITATION_FAIL:
            return {
                ...state,
                error: action?.payload
            }

        case Action.ADMIN_GET_OFFERCODES_INIT:
            return {
                ...state
            }
        case Action.ADMIN_GET_OFFERCODES_SUCCESS:
            return {
                ...state,
                AllOfferCodes: action?.payload
            }
        case Action.ADMIN_GET_OFFERCODES_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.ADMIN_ADD_OFFERCODE_INIT:
            return {
                    ...state
            }
        case Action.ADMIN_ADD_OFFERCODE_SUCCESS:
            return {
                    ...state,
                    offerCode: action?.payload
            }
        case Action.ADMIN_ADD_OFFERCODE_FAIL:
                return {
                    ...state,
                    error: action?.payload
                }
        case Action.ADMIN_DELETE_OFFERCODE_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.ADMIN_DELETE_OFFERCODE_INIT:
                return {
                        ...state
                }
        case Action.ADMIN_DELETE_OFFERCODE_SUCCESS:
                return {
                        ...state,
                        offerCode: action?.payload
                }
        case Action.ADMIN_UPDATE_OFFERCODE_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.ADMIN_UPDATE_OFFERCODE_INIT:
                return {
                        ...state
                }
        case Action.ADMIN_UPDATE_OFFERCODE_SUCCESS:
                return {
                        ...state,
                        offerCode: action?.payload
                }
       
      
        case Action.ADMIN_GET_REFERRALS_INIT:
            return {
                ...state
            }
        case Action.ADMIN_GET_REFERRALS_SUCCESS:
            return {
                ...state,
                AllReferrals: action?.payload
            }
        case Action.ADMIN_GET_REFERRALS_FAIL:
            return {
                ...state,
                error: action?.payload
            }

        case Action.ADMIN_UPDATE_REFERRAL_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.ADMIN_UPDATE_REFERRAL_INIT:
                return {
                        ...state
                }
        case Action.ADMIN_UPDATE_REFERRAL_SUCCESS:
                return {
                        ...state,
                        referral: action?.payload
                }
        case Action.ADMIN_ADD_REFERRAL_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.ADMIN_ADD_REFERRAL_INIT:
                return {
                        ...state
                }
        case Action.ADMIN_ADD_REFERRAL_SUCCESS:
                return {
                        ...state,
                        referral: action?.payload
                }

        case Action.ADMIN_DELETE_REFERRAL_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.ADMIN_DELETE_REFERRAL_INIT:
                return {
                        ...state
                }
        case Action.ADMIN_DELETE_REFERRAL_SUCCESS:
                return {
                        ...state,
                        referral: action?.payload
                }

        // Affiliate management cases
        case Action.ADMIN_GET_AFFILIATES_INIT:
            return {
                ...state
            }
        case Action.ADMIN_GET_AFFILIATES_SUCCESS:
            return {
                ...state,
                AllAffiliates: action?.payload
            }
        case Action.ADMIN_GET_AFFILIATES_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.ADMIN_ADD_AFFILIATE_INIT:
            return {
                ...state
            }
        case Action.ADMIN_ADD_AFFILIATE_SUCCESS:
            return {
                ...state,
                affiliate: action?.payload
            }
        case Action.ADMIN_ADD_AFFILIATE_FAIL:
            return {
                ...state,
                error: action?.payload
            }

        // Custom Plans management cases
        case Action.ADMIN_GET_CUSTOM_PLANS_INIT:
            return {
                ...state
            }
        case Action.ADMIN_GET_CUSTOM_PLANS_SUCCESS:
            return {
                ...state,
                AllCustomPlans: action?.payload
            }
        case Action.ADMIN_GET_CUSTOM_PLANS_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.ADMIN_ADD_CUSTOM_PLAN_INIT:
            return {
                ...state
            }
        case Action.ADMIN_ADD_CUSTOM_PLAN_SUCCESS:
            return {
                ...state,
                customPlan: action?.payload
            }
        case Action.ADMIN_ADD_CUSTOM_PLAN_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        
        case Action.ADMIN_GET_PLAN_FEATURES_INIT:
            return {
                ...state,
            }
        case Action.ADMIN_GET_PLAN_FEATURES_SUCCESS:
            return {
                ...state,
                planFeatures: action?.payload
            }
        case Action.ADMIN_GET_PLAN_FEATURES_FAIL:
            return {
                ...state,
                error: action?.payload,
            }

        case Action.ADMIN_GET_ALLUSER_INIT:
            return {
                ...state
            }
        case Action.ADMIN_GET_ALLUSER_SUCCESS:
            return {
                ...state,
                AllUser: action?.payload
            }
        case Action.ADMIN_GET_ALLUSER_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.GET_USERBY_ID_INIT:
            return {
                ...state
            }
        case Action.GET_USERBY_ID_SUCCESS:
            return {
                ...state,
                UserById: action?.payload
            }
        case Action.GET_USERBY_ID_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.ADMIN_GET_ALLUSER_DOWNLOAD_INIT:
            return {
                ...state
            }
        case Action.ADMIN_GET_ALLUSER_DOWNLOAD_SUCCESS:
            return {
                ...state,
                downloaduser: action?.payload
            }
        case Action.ADMIN_GET_ALLUSER_DOWNLOAD_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.UPDATE_USER_INIT:
            return {
                ...state
            }
        case Action.UPDATE_USER_SUCCESS:
            return {
                ...state
            }
        case Action.UPDATE_USER_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.DELETE_USER_INIT:
            return {
                ...state
            }
        case Action.DELETE_USER_SUCCESS:
            return {
                ...state
            }
        case Action.DELETE_USER_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        case Action.ADD_USER_INIT:
            return {
                ...state
            }
        case Action.ADD_USER_SUCCESS:
            return {
                ...state
            }
        case Action.ADD_USER_FAIL:
            return {
                ...state,
                error: action?.payload
            }
        default:
            return state;
    }
}
export default store;
